import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { nowTickState } from "../state/atoms";

export default function useNowTick(intervalMs = 30000) {
  const setTick = useSetRecoilState(nowTickState);
  useEffect(() => {
    const update = () => setTick(Date.now());
    update();
    const id = setInterval(update, intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, setTick]);
}
